import { defaultObj } from './state'

// Utilities
import Device from '../../utility/deviceUtil'
import Logger from '../../utility/loggerUtil'

export default {
  toggleSidebar (state) {
    state.sidebarOpen = !state.sidebarOpen
  },

  closeSidebar (state) {
    state.sidebarOpen = false
  },

  setMultipleAccounts (state, data) {
    state.multipleAccounts = data
  },

  showHidePaidOffToggle (state, data) {
    state.showAllLoansToggle = data
  },

  setShowAllLoans (state, data) {
    state.showAllLoans = data
  },

  preventScroll (state) {
    state.allowScroll = false
  },

  allowScroll (state) {
    state.allowScroll = true
  },

  preventHeaderClick (state) {
    state.preventHeaderClick = true
  },

  allowHeaderClick (state) {
    state.preventHeaderClick = false
  },

  setDeviceBrowserInfo (state) {
    if (state.hasSetDeviceBrowser) {
      return
    }

    state.isMobileBrowser = Device.getIsMobileDevice()
    state.mobileOs = Device.getMobileOs()
    state.desktopOs = Device.getDesktopOs()
    state.browserType = Device.getBrowserType()
    state.isPwa = Device.getIsPwa()
    state.supportsPwaPrompt = window.hasOwnProperty('onbeforeinstallprompt')
    state.hasSetDeviceBrowser = true
  },

  updateHeader (state, headerData) {
    Logger.debug('Store header mutation data:')
    Logger.debug(JSON.stringify(headerData))

    if (headerData.hasOwnProperty('text')) {
      state.header.text = headerData.text
    } else {
      state.header.text = ''
    }

    if (headerData.hasOwnProperty('buttonType')) {
      state.header.buttonType = headerData.buttonType
    }

    if (headerData.hasOwnProperty('ariaHeader')) {
      state.ariaHeader = headerData.ariaHeader
    } else {
      state.ariaHeader = ''
    }
  },

  reset (state) {
    state = Object.assign(state, defaultObj)
  }
}
